"use client";

/**
 * This is documentation for the Code component.
 */
import * as stylex from "@stylexjs/stylex";
import * as React from "react";
import { codeToHtml } from "shiki";
import { useBlock } from "timvir/core";
import { layoutStyles } from "../../core/layout";
import { cx } from "../../internal/cx";
/**
 * The underlying DOM element which is rendered by this component.
 */
const Root = "div";
export function Code(props) {
  const block = useBlock(props);
  const {
    children,
    language,
    highlightedLines,
    caption,
    className,
    ...rest
  } = block.props;
  const [state, setState] = React.useState({
    settled: false,
    /*
    * Prevent layout shift during (asynchronous) highlighting of the markup by
    * initializing the html with a pre/code block with the expected number of
    * lines.
    */
    html: `<pre class="${{
      className: "x1lliihq x1ghz6dp x1g8o3q3 x1d0dlzq"
    }.className ?? ""}"><code>${children.trim().split("\n").map(() => "\n").join("")}</code></pre>`
  });
  React.useEffect(() => {
    (async () => {
      const stylexTransformer = {
        name: "stylex",
        pre(node) {
          const {
            className: className_0
          } = {
            className: "x1lliihq x1ghz6dp x1g8o3q3 x1d0dlzq"
          };
          if (className_0) {
            this.addClassToHast(node, className_0);
          }
        },
        line(node_0, index) {
          const {
            className: className_1
          } = {
            className: "x1rg5ohu xh8yej3 xe193im"
          };
          if (className_1) {
            this.addClassToHast(node_0, className_1);
          }
          if (highlightedLines?.includes(index)) {
            const {
              className: className_2
            } = {
              className: "x15fpjw5"
            };
            if (className_2) {
              this.addClassToHast(node_0, className_2);
            }
          }
        }
      };
      const html = await codeToHtml(children.trim(), {
        lang: language ?? "text",
        themes: {
          light: "github-light",
          dark: "github-dark"
        },
        defaultColor: false,
        cssVariablePrefix: "--timvir-b-Code-shiki-",
        transformers: [stylexTransformer]
      });
      setState(state_0 => ({
        ...state_0,
        settled: true,
        html
      }));
    })();
  }, [children, language, highlightedLines]);
  const rootStyleProps = stylex.props(layoutStyles.block);
  return <Root data-timvir-b-code {...rest} {...rootStyleProps} className={cx(!state.settled && "timvir-unsettled", className, rootStyleProps.className)} style={{
    ...rootStyleProps.style,
    ...rest.style
  }}>
      <div data-timvir-b-code-container className="xw2csxc x6wvzqs xsfzzmd x1sxf85j xi27niw xidmeni x1717udv x1etwjqo xmkeg23 x1y0btm7 xj7gikm x1d0dlzq" // biome-ignore lint/security/noDangerouslySetInnerHtml: HTML is generated by Shiki and can be trusted
    dangerouslySetInnerHTML={{
      __html: state.html
    }} />

      {caption && <div data-timvir-b-code-caption className="x1dcheo9 xjkpybl xvgvpxu xlwy1ot">
          {caption}
        </div>}
    </Root>;
}